import { getLocalStorage, StorageKey } from './shared/utils/localStorages';
import { store } from './store';

export const updateProfile = <T extends object>({
  land,
  step,
  topicType,
  topic,
  answer,
  guestId = '',
}: {
  land: string;
  step: string;
  topicType: string;
  topic: string;
  answer: T;
  guestId?: string;
}) => {
  const guestIdFromLS = getLocalStorage(StorageKey.UserId);
  const guestAuthId = guestId || guestIdFromLS || store.getState().guestId;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const url = `${baseUrl}/profile/onboarding`;

  fetch(url, {
    method: 'POST',
    headers: {
      'Guest-Authorization': `Bearer ${guestAuthId}`,
    },
    body: JSON.stringify({
      innerId: `quizzes_${land}_${step}`,
      type: topicType,
      topic: topic,
      answer: answer,
    }),
  })
    .then((r) => {
      if (r.ok) {
        return r.json();
      }
    })
    .catch((err) => console.error(err));
};
